import { Doubts } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { useTranslation } from 'Hooks/useTranslation';
import { doubtsList } from './utils';
import * as Styled from './styles';

const DgQuestions = (): JSX.Element => {
  const { t } = useTranslation(locizeNS.DG);
  const handleClick = (e: React.MouseEvent): void => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleKeyDown = (e: React.KeyboardEvent): void => {
    e.preventDefault();
    e.stopPropagation();
  };

  return (
    <Styled.QuestionsButton
      type="button"
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      aria-label={t('DataGathering.faq.title')}
    >
      <Doubts size="M" headerLabel={t('DataGathering.faq.title')} listDoubts={doubtsList()} />
    </Styled.QuestionsButton>
  );
};

export default DgQuestions;
